import { initLines } from "../line-ticker";
import { initHoverMedia } from "../hover-media";

export default () => {
	const lines = document.querySelectorAll('.js-home-line-container');

	setTimeout(() => {
		initLines(lines);
		const hoverBlocks = document.querySelectorAll('.js-marquee-hover-media');
		initHoverMedia(hoverBlocks);
	}, 2000);
}
